import { createContext } from "react";

export interface MenuCondensedContextType {
  isCondensed: boolean;
}

export const MenuCondensedContext = createContext<MenuCondensedContextType>({
  isCondensed: false,
});
